export default "__VITE_ASSET__CNLwtvM0__"